import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon-address-bg.png'
import _imports_1 from '../assets/icon-address-edit.png'


const _withScopeId = n => (_pushScopeId("data-v-c51d0eae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-content" }
const _hoisted_3 = {
  key: 0,
  class: "order-address"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "收货地址", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "添加地址 +", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "order-address"
}
const _hoisted_9 = { class: "order-address-content" }
const _hoisted_10 = { class: "info-address" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_14 = { class: "order-list" }
const _hoisted_15 = { class: "order-list-product" }
const _hoisted_16 = { class: "product-img" }
const _hoisted_17 = { class: "product-info" }
const _hoisted_18 = { class: "order-list-info" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品金额", -1))
const _hoisted_20 = { class: "order-list-info" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运费", -1))
const _hoisted_22 = { class: "order-confirm" }
const _hoisted_23 = { class: "order-confirm-cost" }
const _hoisted_24 = { class: "num" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "show-title" }, "收货地址", -1))
const _hoisted_27 = { class: "button" }

import { ref, onMounted, watch, onActivated } from "vue";
  import { showDialog,showConfirmDialog,showToast } from "vant";
  import { useRouter } from "vue-router";
  import {
    getAddressTree,
    saveCustomerAddress,
    getCustomerAddress,
    createOrder,
    editCustomerAddress,
    getProductDetails
  } from "@/server/api";
  import { useStore } from "vuex";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderConfirm',
  setup(__props) {

  const $router = useRouter();
  const store = useStore(); // 该方法用于返回store 实例
  
  const anotherCount = ref(0);
  const showBottom = ref(false);
  const active = ref(0);
  let userAddressInfo = ref({});
  const loading = ref(false);
  const finished = ref(false);
  let userName = ref("");
  let phone = ref("");
  const address = ref("");
  let addressDetail = ref("");
  const showCascader = ref(false);
  const fieldValue = ref("");
  const productInfo = ref({});
  const tempProductInfo = ref({});
  const cascaderValue = ref("");
  const customLevel = ref('');
  
  let cascaderOptions: never[] = [];
  let addressSelectedOptions: { addressName: string }[] = [];
  // 地址联级选择器自定义字段映射
  const fieldNames = {
    text: "addressName",
    value: "addressCode",
    children: "subAddressList",
  };
  
  onActivated(() => {
      getAddress();
      getAdsTree()
      customLevel.value = $router.currentRoute.value.query?.customLevel as string;
      tempProductInfo.value = store.state.exchangeDetails.value ? store.state.exchangeDetails : JSON.parse(window.localStorage.getItem('exchangeDetails') as string);
      if(tempProductInfo.value.productCode) {
          getDetails(tempProductInfo.value.productCode)
      }
  });
  
  const getDetails = async(id : string) => {
      const custom = !customLevel.value || customLevel.value == 'null'? {} : {
          customLevel: customLevel.value
      }
      const params = {
          skuCode: id,
          ...custom
      }
      
      const { data } = await getProductDetails(params);
      const _temp = JSON.parse(JSON.stringify(tempProductInfo.value))
      productInfo.value = Object.assign(_temp, data);
  
      console.log('tempProductInfo=>', tempProductInfo.value)
  }
  
  const userId = store.state.openId || window.localStorage.getItem('openId');
  let customerAddress = { 
    addressee: '',
    addresseePhone: '',
    province: '',
    city: '',
    district: '',
    street: '',
    addressDetail: ''
   };
  const validatorMessage = (val: string) => {
    if (val?.length < 1) {
      return `收货人姓名必须1-20个字符`;
    }
  };
  const validatorPhone = (val: string) => {
      var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      var result = re.test(val); 
      if(!result) {
          return '手机号码格式不正确！'; 
      }
      return true;
  }
  
  const addAddress = () => {
    showBottom.value = true;
  };
  
  const onSubmit = async (values: any) => {
    userAddressInfo.value = values;
    // 用户没有点击地址联级菜单修改地址时将原地址作为入参
    const params = {
      id: customerAddress.id, 
      uid: userId,
      addressee: userName.value,
      addresseePhone: phone.value,
      province: addressSelectedOptions[0]?.addressName || customerAddress.province || "",
      city: addressSelectedOptions[1]?.addressName || customerAddress.city || "",
      district: addressSelectedOptions[2]?.addressName || customerAddress.district || "",
      street: addressSelectedOptions[3]?.addressName || customerAddress.street || "",
      addressDetail: addressDetail.value,
    };
    console.log('customerAddress',customerAddress);
    let res = {};
    if (!customerAddress.id) {
        res = await saveCustomerAddress(params);
    } else {
        res = await editCustomerAddress(params);
    }
    
    if(!res.errorCode) {
        getAddress();
        showBottom.value = false;
    }else {
        showToast(res.errorMessage)
    }
    
  };
  
  // 全部选项选择完毕后，触发 finish 事件
  const onFinish = ({ selectedOptions }: any) => {
  
      console.log('selectedOptions==>', selectedOptions)
    showCascader.value = false;
    address.value = selectedOptions
      .map((option: any) => option.addressName)
      .join(" ");
    addressSelectedOptions = selectedOptions;
  };
  
  const isNotEmptyObject = (obj: any) => {
    const arr = Object.keys(obj);
    return arr.length;
  };
  
  const editAddress = () => {
    if (customerAddress) {
      userName.value = customerAddress.addressee;
      phone.value = customerAddress.addresseePhone;
      address.value = `${customerAddress.province} ${customerAddress.city} ${customerAddress.district} ${customerAddress.street}`;
      addressDetail.value = customerAddress.addressDetail;
    }
    showBottom.value = true;
  };
  
  const confirmOrder = async (userAddressInfo: any) => {
      if(tempProductInfo.value.points !== productInfo.value.points || 
      tempProductInfo.value.userFreightPoints !== productInfo.value.userFreightPoints) {
          showConfirmDialog({
              message: '当前商品积分已发生变动，请重新提交订单',
              theme: 'round-button',
              confirmButtonText: '继续提交',
              cancelButtonText: '取消',
              className: 'custom-btn'
          }).then(() => {
              showConfirmDialog({
                  message: '订单提交后无法修改地址，请确认您选择了正确的地址。',
                  theme: 'round-button',
                  confirmButtonText: '确认提交',
                  cancelButtonText: '返回检查',
                  className: 'custom-btn'
              }).then(() => {
                  confirmSave(userAddressInfo)
              })
              .catch(() => {
                  // on cancel
              });
          })
          .catch(() => {
              history.back();
          });
  
          return
      }
  
      showConfirmDialog({
          message: '订单提交后无法修改地址，请确认您选择了正确的地址。',
          theme: 'round-button',
          confirmButtonText: '确认提交',
          cancelButtonText: '返回检查',
          className: 'custom-btn'
      }).then(() => {
          confirmSave(userAddressInfo)
      })
      .catch(() => {
          // on cancel
      });
  };
  
  const confirmSave = async (userAddressInfo: any) => {
  
      if (!isNotEmptyObject(userAddressInfo)) {
          return;
      }else {
          const params = {
              uid: userId,
              brand: store.state.currentState === 'clinique' ? 'CL' : 'OR',
              productCode: productInfo.value.productCode,
              quantity: productInfo.value.exchangeNum,
              addressId: userAddressInfo.id,
              expressPoints: productInfo.value.userFreightPoints,
              points: productInfo.value.points
          }
          const res = await createOrder(params);
          if(!res.errorCode) {
              const num = productInfo.value.exchangeNum * productInfo.value.points + productInfo.value.userFreightPoints;
              $router.push({
                  name: 'exchangeSuccess',
                  query: {
                      price: num
                  }
              })
          }else {
              if (res.errorCode === 300011) {
                  showDialog({
                      message: res.errorMessage,
                      theme: 'round-button',
                      confirmButtonText: '我知道了'
                  }).then(() => {
                      history.back();
                  });
              }else if(res.errorCode === 881006) {
                  showDialog({
                      message: res.errorMessage,
                      theme: 'round-button',
                      confirmButtonText: '返回'
                  }).then(() => {
                      history.back();
                  });
              }else {
                  showToast(res.errorMessage)
              }
          }
      }
  }
  
  // 打开地区联级弹窗
  const showCascaderPop = async () => {
      showCascader.value = true;
  };
  
  const getAdsTree = async () => {
      const { data } = await getAddressTree();
      cascaderOptions = data;
      findCan(data);
  }
  
  const findCan = function (V: any) {
        V.forEach((item : any) => { // 把传入的数组循环遍历
            if(customerAddress.street !== '我不清楚' ) {
                if (item.addressName === customerAddress.street) {
                    cascaderValue.value = item.addressCode;
                }
            }else {
                if (item.addressName === customerAddress.district) {
                    cascaderValue.value = item.addressCode;
                }
            }
          
            if (item.subAddressList) {
                findCan(item.subAddressList) // 递归调用自身
            }
        })
  }
  
  // 获取用户地址
  const getAddress = async () => {
    const params = {
      userId: userId,
    };
    const { data } = await getCustomerAddress(params);
    if(data) {
      userAddressInfo.value = {
          addressDetail: `${data.province} ${data.city} ${data.district} ${data.street === '我不清楚'? '' : data.street} ${data.addressDetail}`,
          userName: data.addressee,
          phone: data.addresseePhone,
          id: data.id
      }
      customerAddress = data;
    }
   
  };
  
return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_cascader = _resolveComponent("van-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!isNotEmptyObject(_unref(userAddressInfo)))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "order-address-empty",
              onClick: addAddress
            }, _hoisted_7)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(userAddressInfo)?.userName), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(userAddressInfo)?.phone), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_unref(userAddressInfo)?.address) + " " + _toDisplayString(_unref(userAddressInfo)?.addressDetail), 1)
              ]),
              _createElementVNode("div", {
                class: "address-edit",
                onClick: editAddress
              }, _hoisted_12),
              _hoisted_13
            ])
          ])),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_van_image, {
              src: productInfo.value.masterDiagramUrl
            }, {
              loading: _withCtx(() => [
                _createVNode(_component_van_loading, {
                  type: "spinner",
                  size: "20"
                })
              ]),
              _: 1
            }, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", null, _toDisplayString(productInfo.value.productName), 1),
            _createElementVNode("p", null, _toDisplayString(productInfo.value.description), 1),
            _createElementVNode("p", null, [
              _createElementVNode("span", null, "x" + _toDisplayString(productInfo.value.exchangeNum), 1)
            ])
          ])
        ]),
        _createElementVNode("p", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", null, [
            _createElementVNode("em", null, _toDisplayString(productInfo.value.points), 1),
            _createTextVNode("积分")
          ])
        ]),
        _createElementVNode("p", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", null, [
            _createElementVNode("em", null, _toDisplayString(productInfo.value.userFreightPoints), 1),
            _createTextVNode("积分")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("p", null, [
            _createTextVNode(" 共 "),
            _createElementVNode("span", _hoisted_24, _toDisplayString(productInfo.value.exchangeNum), 1),
            _createTextVNode(" 件"),
            _hoisted_25,
            _createTextVNode("共计："),
            _createElementVNode("span", null, _toDisplayString(productInfo.value.exchangeNum * productInfo.value.points +
                productInfo.value.userFreightPoints), 1),
            _createTextVNode(" 积分 ")
          ]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmOrder(_unref(userAddressInfo)))),
            class: _normalizeClass([
                'button',
                !isNotEmptyObject(_unref(userAddressInfo)) ? 'gray' : '',
              ])
          }, " 提交订单 ", 2)
        ])
      ]),
      _createVNode(_component_van_popup, {
        show: showBottom.value,
        "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showBottom).value = $event)),
        closeable: "",
        round: "",
        position: "bottom",
        class: "add-address",
        style: { height: '70%' }
      }, {
        default: _withCtx(() => [
          _hoisted_26,
          _createVNode(_component_van_form, { onSubmit: onSubmit }, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    "label-class": "label-info",
                    modelValue: _unref(userName),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(userName) ? (userName).value = $event : userName = $event)),
                    name: "userName",
                    label: "收货人",
                    placeholder: "请输入收货人姓名",
                    maxlength: "10",
                    rules: [
                  {
                    validator: validatorMessage,
                    required: true,
                    message: '请填写收货人姓名',
                  },
                ]
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_van_field, {
                    "label-class": "label-info",
                    modelValue: _unref(phone),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(phone) ? (phone).value = $event : phone = $event)),
                    type: "tel",
                    name: "phone",
                    label: "联系电话",
                    placeholder: "请输入电话号码",
                    rules: [{ required: true, message: '请填写电话号码', validator: validatorPhone, }]
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_van_field, {
                    "label-class": "label-info",
                    modelValue: address.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((address).value = $event)),
                    name: "address",
                    label: "收货地区",
                    placeholder: "省、市、区、街道",
                    readonly: true,
                    onClick: showCascaderPop,
                    rules: [{ required: true, message: '请选择收货地址' }]
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    "label-class": "label-info",
                    modelValue: _unref(addressDetail),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(addressDetail) ? (addressDetail).value = $event : addressDetail = $event)),
                    type: "textarea",
                    name: "addressDetail",
                    label: "详细地址",
                    maxlength: "100",
                    placeholder: "如小区、楼栋号、门牌号等如小区、楼栋号、门牌号等",
                    rules: [{ required: true, message: '请输入具体地址' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_van_button, {
                  round: "",
                  block: "",
                  type: "primary",
                  color: "#FF3469",
                  "native-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存并使用")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_van_popup, {
        show: showCascader.value,
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((showCascader).value = $event)),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cascader, {
            modelValue: cascaderValue.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((cascaderValue).value = $event)),
            title: "所在地区",
            options: _unref(cascaderOptions),
            "field-names": fieldNames,
            "active-color": "#FF3469",
            onClose: _cache[7] || (_cache[7] = ($event: any) => (showCascader.value = false)),
            onFinish: onFinish
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}
}

})